
import * as React from 'react';
import { withRouter, BrowserHistory } from "react-router-dom";
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { CircularProgress, Button, Card, CardText, CardTitle, CardActions } from 'react-md';
import { IApi } from '../../utility/IApi';
import { AccountStatus } from '../../model/ModelTypes';

export class VerfiyAccountModel {

    @observable asyncOperationsCount = 0;
    @observable executionCompleted = false;
    @observable withError = false;
    @observable cardTitle = "";
    @observable cardSubtitle = "";
    @observable cardText = "";
    private api: IApi; 
    constructor(api: IApi) {
        this.api = api;
    }

    @action.bound
    incrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
    }

    @action.bound
    decrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount - 1;
    }

    @action.bound
    setCardWithPendingAdminApproval() {
        this.cardTitle = "Approval Required";
        this.cardSubtitle = "Admin Approval is required for your account";
        this.cardText = "Your email has been verified but an Admin needs to approve your account. ";
        this.cardText += "Please notify your Admin to speed up the process";
    }
    @action.bound
    setCardWithApproved() {
        this.cardTitle = "Account Approved";
        this.cardSubtitle = "Your Account is Approved";
        this.cardText = "Your email has been verified. You can now login to the Portal and the mobile App.";
    }
    @action.bound
    setCardWithError() {
        this.cardTitle = "Approval Required";
        this.cardSubtitle = "Admin Approval is required for your account";
        this.cardText = "Your email has not been verified. An Admin needs to approve your account. ";
        this.cardText += "Please notify your Admin to speed up the process";
    }
    @action
    verifyAccount(organisationCode: string, code: string) {
        this.incrementAsyncOperations();
        this.api.executeVerifyAccount(organisationCode, code)
        .subscribe(
            result => {
                switch (result) {
                    case AccountStatus.approved:
                        this.setCardWithApproved();
                        this.decrementAsyncOperations();
                        this.executionCompleted = true;
                        break;
                    case AccountStatus.PendingAdminApproval:
                        this.setCardWithPendingAdminApproval();
                        this.decrementAsyncOperations();
                        this.executionCompleted = true;
                        break;
                    default:
                        this.setCardWithError();
                        this.decrementAsyncOperations();
                        this.executionCompleted = true;
                }
            }
            ,
            error => {
                this.setCardWithError();
                this.decrementAsyncOperations();
                this.executionCompleted = true;
            }
        );
        
    }
 }

@observer class VerfiyAccount
    extends
    React.Component<
    {
        orgCode: string,
        code: string,
        model: VerfiyAccountModel, history: BrowserHistory
    }, {}> {

    componentDidMount() {
        setTimeout(
            () => {
            this.props.model.verifyAccount(this.props.orgCode, this.props.code);
        },  1000);
    }

    render() {
        return (
            <div className="container">
            {
                this.props.model.asyncOperationsCount > 0 &&
                !this.props.model.executionCompleted &&
                <CircularProgress centered={true} id="Progress" />
            }
            {
                this.props.model.asyncOperationsCount === 0 &&
                this.props.model.executionCompleted &&
                <Card className="">
                    <CardTitle 
                        title={this.props.model.cardTitle}
                        subtitle={this.props.model.cardSubtitle}
                    />
                    <CardText className="">
                        <p>
                            {this.props.model.cardText}
                        </p>
                    </CardText>
                    <CardActions className="md-divider-border md-divider-border--top">
                        <Button 
                            flat={true} 
                            secondary={true}
                            onClick={() => this.props.history.push("/login")}
                        >
                        Go To Login
                        </Button>
                    </CardActions>
                </Card>
            }
            </div>
        );
    }

}

export default withRouter(VerfiyAccount);


// WEBPACK FOOTER //
// ./src/view/VerifyAccount/VerifyAccount.tsx